<ng-container [ngSwitch]="type">
  <lib-html-video-player
    *ngSwitchCase="VideoTemplateType.Import"
    class="video-player"
    [mediaConfig]="mediaConfig"
    [url]="url"
    [thumbnailUrl]="thumbnailUrl"
    [animationType]="animationType"
    [displayTime]="displayTime"
    [contentDuration]="contentDuration"
    (ready)="onPlayerReady()"
    (error)="onPlayerError($event)">
  </lib-html-video-player>

  <lib-vimeo-player
    *ngSwitchCase="VideoTemplateType.Vimeo"
    class="video-player"
    [mediaConfig]="mediaConfig"
    [url]="url"
    (ready)="onPlayerReady()"
    (error)="onPlayerError($event)">
  </lib-vimeo-player>

  <lib-youtube-player
    *ngSwitchCase="VideoTemplateType.YouTube"
    class="video-player"
    [templateName]="templateName"
    [mediaConfig]="mediaConfig"
    [url]="url"
    (ready)="onPlayerReady()"
    (error)="onPlayerError($event)">
  </lib-youtube-player>

</ng-container>
